module.exports = __webpack_public_path__ + "img/animated.b44761c3.gif";